import { render, staticRenderFns } from "./ScopesTab.vue?vue&type=template&id=69d758bb"
import script from "./ScopesTab.vue?vue&type=script&lang=js"
export * from "./ScopesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports